import async from 'async';
import Compress from 'compress.js';
/* eslint-disable */
export default {
    methods: {
        singeFileUploader (image) {
            const self = this;
            return new Promise((resolve, reject) => {
                self.compress(image.file, (err, file) => {
                    if(err) throw err;
                    self.$store.dispatch('FETCH_SIGNED_URI', {type: "users", "content-type": file.type}).then(resp => {
                        self.$store.dispatch('UPLOAD_FILE', {uri: resp.data.response.signedRequest, file: file}).then(res => {
                            console.log("res", res);
                            resolve(resp.data.response.url);
                        }).catch(err => {
                            console.log("err", err);
                            reject(err);
                        });
                        //self.registration.imageURI = resp.data.response.url;
                        //self.$store.dispatch(USER, self.registration);
                    }).catch(err => {
                        reject(err);
                    });
                });
            });
        },
        multiFileUploader (files) {
            const self = this;
            return new Promise((resolve, reject) => {
                const asyncFuncs = [], urls = [];
                files.forEach(file => {
                    asyncFuncs.push(cb => {
                        self.compress(file.file, (err, f) => {
                            if(err) throw err;
                            self.$store.dispatch('FETCH_SIGNED_URI', {type: "items", "content-type": f.type}).then(resp => {
                                self.$store.dispatch('UPLOAD_FILE', {uri: resp.data.response.signedRequest, file: f});
                                urls.push(resp.data.response.url);
                                cb();
                            }).catch(err => {
                                cb(err);
                            });
                        });
                    });
                });
                async.parallel(asyncFuncs, err => {
                    if(err) return reject(err);
                    resolve(urls);
                });
            });
        },
        compress(file, cb) {
            if(file.type.indexOf('video') > -1 || (file.size/1024) < 50) return cb(null, file);
            const compress = new Compress();
            const files = [file];
            compress.compress(files, {
                size: 1, // the max size in MB, defaults to 2MB
                quality: .3, // the quality of the image, max is 1,
                resize: false, // defaults to true, set false if you do not want to resize the image width and height
            }).then((results) => {
                const url = results[0].prefix+results[0].data, filename = results[0].alt, mimeType = results[0].ext;
                fetch(url).then(function(res){
                    return res.arrayBuffer();
                }).then(function(buf){
                    return cb(null, new File([buf], filename, {type:mimeType}));
                });
            }).catch(err => {
                throw err;
            });
        },
        deleteFiles(files) {;
            files.forEach(file => {
                this.$store.dispatch('S3_DELETE', {fileName: file}).then(resp => {
                    console.log("S3 File deleted", files, resp);
                }).catch(err => {
                    console.log("S3 File delete error", files, err);
                });
            });
        }
    }
}